// extracted by mini-css-extract-plugin
module.exports = {"result_controls":"ResultControls_result_controls__3kuxc"};